import React from 'react'
import { toast, ToastContainer } from 'react-toastify'

import { ArtworkEditor } from '@domain-group/artwork-builder'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-light-svg-icons'

import '@domain-group/artwork-builder/dist/styles.css'

import useArtworkBuilder from '@hooks/useArtworkBuilder'

import { useSelector } from 'react-redux'
import { useAuth0 } from '@auth0/auth0-react'

import { useEffect } from 'react'

const CloseButton = ({ closeToast }) => (
  <a onClick={closeToast}>
    <FontAwesomeIcon icon={faTimes} />
  </a>
)

const selectSavedArtworkPage = async (savedArtworkPage, createFn, loadShortcodeDataFn, selectArtworkPageId, requestOptions, setState) => {
  const { artworkConfig, ...options } = requestOptions || {}
  const { campaigntrackOrderItemId } = artworkConfig || {}

  const shortcodeDataResult = await loadShortcodeDataFn({ id: campaigntrackOrderItemId })
  const { data: customShortcodeData } = shortcodeDataResult

  const mergedOptions = {
    ...options,
    custom_data: customShortcodeData,
  }

  createFn(savedArtworkPage, mergedOptions).then((response) => {
    const { success, data, errors } = response
    if (!success && errors){
      toast.warn(errors[0])
      return
    }

    selectArtworkPageId(data.id)

    setState({ showSelectTemplateModal: false })
  })
}

const selectTemplatePage = async (templatePage, createFn, loadShortcodeDataFn, selectArtworkPageId, requestOptions, setState) => {
  const { artworkConfig, ...options } = requestOptions || {}
  const { campaigntrackOrderItemId } = artworkConfig || {}

  const shortcodeDataResult = await loadShortcodeDataFn({ id: campaigntrackOrderItemId })
  const { data: customShortcodeData } = shortcodeDataResult

  const mergedOptions = {
    ...options,
    custom_data: customShortcodeData,
  }

  createFn(templatePage, mergedOptions).then((response) => {
    const { success, data, errors } = response
    if (!success && errors){
      toast.warn(errors[0])
      return
    }

    selectArtworkPageId(data.id)

    setState({ showSelectTemplateModal: false })
  })

  useEffect(() => {
    window.newrelic?.setCustomAttribute("Realhub Order Item ID", campaigntrackOrderItemId);
    window.newrelic?.setCustomAttribute("Realhub Artwork ID", selectArtworkPageId);
    window.newrelic?.setCustomAttribute("Realhub Template", templatePage);
  }, [campaigntrackOrderItemId, selectArtworkPageId, templatePage]);
}

const replaceArtworkPageTemplatePage = async (
  artworkPage,
  templatePage,
  updateFn,
  loadShortcodeDataFn,
  requestOptions,
  setState,
) => {
  const { artworkConfig, ...options } = requestOptions || {}
  const { campaigntrackOrderItemId } = artworkConfig || {}

  const shortcodeDataResult = await loadShortcodeDataFn({ id: campaigntrackOrderItemId })
  const { data: customShortcodeData } = shortcodeDataResult

  const mergedOptions = {
    ...options,
    custom_data: customShortcodeData,
  }

  updateFn(artworkPage, templatePage, mergedOptions).then((response) => {
    const { success, errors } = response
    if (!success && errors){
      toast.warn(errors[0])
      return
    }

    setState({ showSelectTemplateModal: false })
  })
}

const getCookie = (name: string) => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  return match ? match[2] : null
}

const EditPage = () => {
  const {
    callbacks: {
      deleteArtwork, fetchEditorOptions, goBack, loadShortcodeData,
    },
  } = useArtworkBuilder()

  const { user } = useAuth0()

  const currentEmail = user.email 

  const lastEmail = getCookie('lastEmail')

  document.cookie = `CurrentEmail=${currentEmail}; path=/; max-age=86400`

  useEffect(() => {
    if (lastEmail === currentEmail){
      const error = new Error('Auth0 possible stale session reuse')
      
    window.newrelic?.noticeError(error, {
        lastEmail,
        currentEmail,
        type: 'AUTH0_SESSION_REUSE',
      })

    window.newrelic?.setCustomAttribute('auth0_session_reused', true)
    }
  })

  return (
    <ArtworkEditor
      callbacks={{
        deleteArtwork,
        fetchEditorOptions,
        goBack,
        replaceArtworkPageTemplatePage: (artworkPage, templatePage, updateFn, requestOptions, setState) => replaceArtworkPageTemplatePage(artworkPage, templatePage, updateFn, loadShortcodeData, requestOptions, setState),
        selectSavedArtworkPage: (savedArtworkPage, createFn, selectArtworkPageId, requestOptions, setState) => selectSavedArtworkPage(savedArtworkPage, createFn, loadShortcodeData, selectArtworkPageId, requestOptions, setState),
        selectTemplatePage: (templatePage, createFn, selectArtworkPageId, requestOptions, setState) => selectTemplatePage(templatePage, createFn, loadShortcodeData, selectArtworkPageId, requestOptions, setState),
      }}
    >
      <ArtworkEditor.Header />
      <ArtworkEditor.Canvas />

      <ToastContainer closeButton={<CloseButton />} hideProgressBar autoClose={5000} />
    </ArtworkEditor>
  )
}

export default EditPage
